exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar-main {\n  border: 0px !important;\n}\n\n.navbar-nav > li > a.header-btn {\n  padding-right: 40px;\n  padding-left: 40px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!/home/runner/_work/monorepo/monorepo/admin-portal-old/node_modules/postcss-loader/lib?{"ident":"postcss","sourceMap":false}!/home/runner/_work/monorepo/monorepo/admin-portal-old/src/header-styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/lib/index.js?{"ident":"postcss","sourceMap":false}!../../../../../src/header-styles.css
// module chunks = styles